// Taken from https://gist.github.com/rohanai/2587603f87ec8fbf943acb01e7f6a9f5
declare const __webpack_init_sharing__: any; // eslint-disable-line @typescript-eslint/naming-convention
declare const __webpack_share_scopes__: any; // eslint-disable-line @typescript-eslint/naming-convention

/* istanbul ignore next */
if (!(globalThis as any).__webinvest_module_getModuleFactory) {
  (globalThis as any).__webinvest_module_getModuleFactory = { moduleCache: {}, logSharedScopes: () => {} };
}

export const moduleCache: Record<string, any> = (globalThis as any).__webinvest_module_getModuleFactory.moduleCache;
export const logSharedScopes = (...args: any) => {
  (globalThis as any).__webinvest_module_getModuleFactory.logSharedScopes(...args);
};

export const setLogSharedScopes = (log: (...args: any) => void) => {
  (globalThis as any).__webinvest_module_getModuleFactory.logSharedScopes = log;
};

export const getModuleFactory = (appName: any, module: any, log: (...args: any) => void) => {
  const key = `${appName}:${module}`;

  const cachedModule = moduleCache[key];
  if (cachedModule) {
    log(`Dynamic Module ${key} from cache`);
    return { factory: cachedModule, isLazy: false };
  }

  return {
    factory: async () => {
      log(`Dynamic Module ${key} from webpack`);
      // Initializes the share scope. This fills it with known provided modules from this build and all remotes
      await __webpack_init_sharing__('default');
      const container: any = window[appName]; // or get the container somewhere else
      // Initialize the container, it may provide shared modules
      await container.init(__webpack_share_scopes__.default);
      logSharedScopes({ key, appName, '__webpack_share_scopes__.default': __webpack_share_scopes__.default });
      const factory = await container.get(module);
      const Module = factory();
      moduleCache[key] = Module;
      return Module;
    },
    isLazy: true
  };
};
